import { ButtonHTMLAttributes, FunctionComponent, ReactNode } from 'react'
import { Loader2 } from 'lucide-react'
import Modal from 'components/shared/Modal'

interface ConfirmDialogProps {
  open: boolean
  onClose: () => void
  title: ReactNode
  children?: ReactNode
  footnote?: ReactNode
  confirmText?: ReactNode
  onConfirm: () => void
  confirmLoading?: boolean
  cancelText?: ReactNode
  // onCancel defaults to onClose — only provide it when the cancel button needs to do something other than dismiss
  onCancel?: () => void
  cancelLoading?: boolean
  disabled?: boolean
  confirmAttributes?: ButtonHTMLAttributes<HTMLButtonElement> & { [key: `data-${string}`]: string | undefined }
  cancelAttributes?: ButtonHTMLAttributes<HTMLButtonElement> & { [key: `data-${string}`]: string | undefined }
}

const ConfirmDialog: FunctionComponent<ConfirmDialogProps> = ({
  open,
  onClose,
  title,
  children,
  footnote,
  confirmText = 'Confirm',
  onConfirm,
  confirmLoading = false,
  cancelText = 'Cancel',
  onCancel,
  cancelLoading = false,
  disabled = false,
  confirmAttributes = {},
  cancelAttributes = {}
}) => (
  <Modal
    open={open}
    onClose={onClose}
    title={title}
    size='medium'
    footnote={footnote}
    actions={
      <>
        <button
          onClick={onCancel ?? onClose}
          disabled={disabled}
          className='pointer bg-transparent bn f5 black ph5 pv4 br3 hover-bg-ghost-white flex items-center justify-center gap2 flex-1'
          {...cancelAttributes}
        >
          {cancelLoading && <Loader2 size={16} className='spin-to-win' />}
          {cancelText}
        </button>
        <button
          onClick={onConfirm}
          disabled={disabled}
          className='pointer bg-suez-canal br3 ph5 pv4 white f5 bn hover-o-90 flex items-center justify-center gap2 flex-1'
          {...confirmAttributes}
        >
          {confirmLoading && <Loader2 size={16} className='spin-to-win' />}
          {confirmText}
        </button>
      </>
    }
  >
    {children}
  </Modal>
)

export default ConfirmDialog
